import { RouteConfig } from 'src/routing/types'

const ROUTE: RouteConfig = {
  name: 'editor',
  path: () => '/editor',
}

export default ROUTE
